import React from 'react';
import { CircularGauge } from './CircularGauge';
interface GlassCardProps {
  isInView: boolean;
  value?: number;
  color?: 'primary' | 'secondary';
  title?: string;
}
export const GlassCard = ({
  isInView,
  value = 87,
  color = 'secondary',
  title
}: GlassCardProps) => {
  return <div className="flex items-center justify-center relative" style={{
    width: '280px',
    height: '160px',
    borderRadius: '12px',
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    backdropFilter: 'blur(16px)',
    boxShadow: '0 12px 32px rgba(0,0,0,0.10), 0 4px 8px rgba(0,0,0,0.06)',
    border: '4px solid transparent',
    backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)), linear-gradient(to right, rgba(224, 215, 255, 0.4), rgba(183, 233, 233, 0.4))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box'
  }} data-id="element-221">
      <div className="absolute inset-0 rounded-lg" style={{
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      backdropFilter: 'blur(15px)'
    }} data-id="element-222" />
      <div className={`absolute top-3 right-3 w-2 h-2 rounded-full ${color === 'primary' ? 'bg-[#8679DF] ring-[#8679DF]/20' : 'bg-teal-500 ring-teal-500/20'} ring-4`} data-id="element-223" />
      {title && <div className="absolute top-3 left-4 text-sm font-medium text-gray-600" data-id="element-224">
          {title}
        </div>}
      <div className="relative z-10" data-id="element-225">
        <CircularGauge value={value} size={100} strokeWidth={10} isInView={isInView} color={color} data-id="element-226" />
      </div>
    </div>;
};